
import { FETCH_DOCUMENTATION_REQUEST, FETCH_DOCUMENTATION_SUCCESS, FETCH_DOCUMENTATION_FAILURE } from './actionsTypes';

export const fetchDocumentationRequest = (token,history) => ({
  type: FETCH_DOCUMENTATION_REQUEST,
  payload: { token,history },
});

export const fetchDocumentationSuccess = (documentationData) => ({
  type: FETCH_DOCUMENTATION_SUCCESS,
  payload: { documentationData },
});

export const fetchDocumentationFailure = (error) => ({
  type: FETCH_DOCUMENTATION_FAILURE,
  payload: { error },
});

